import { configureStore } from "@reduxjs/toolkit";

import tradeBookReducer           from "./Reducer/tradebooks.slice";
import positionReportReducer      from "./Reducer/Positionreport.slice";
import valanReducer               from "./Reducer/valan.slice";
import commonReducer              from "./Reducer/common.slice";
import bannedBlockedScriptReducer from "./Reducer/bannedblockedscript.slice";
import settingScriptReducer       from "./Reducer/settingscript.slice";
import marketWatchReducer         from "./Reducer/marketwatch.slice";
import orderBookReducer           from "./Reducer/orderbook.slice";
import maxQuantityDetailsReducer  from "./Reducer/maxQuantityDetails.slice";
import authReducer                from "./Reducer/auth.slice";
import reportReducer from "./Reducer/report.slice";
import adminReducer from "./Reducer/adminSlice/admin.slice";
import marginReducer from "./Reducer/margin.slice";

export const store = configureStore({
  reducer: {
    tradeBook           : tradeBookReducer,
    positionReport      : positionReportReducer,
    valan               : valanReducer,
    common              : commonReducer,
    bannedBlockedScript : bannedBlockedScriptReducer,
    settingScript       : settingScriptReducer,
    marketWatch         : marketWatchReducer,
    orderbook           : orderBookReducer,
    maxQuantityDetails  : maxQuantityDetailsReducer,
    auth                : authReducer,
    report              : reportReducer,
    admin: adminReducer,
    margin: marginReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;